import * as React from "react"
import cx from "classnames"

import Link from "@components/elements/link"
import { ConditionalWrapper, isLocalLink } from "@lib/utils"

import ArrowRight from "@images/arrow-right.inline.svg"
import ArrowOut from "@images/arrow-out.inline.svg"

import styles from "./cta.module.scss"

export const CtaContainer = ({ items, className, ctaClassName }) => {
  if (!items.length) {
    return null
  }

  return (
    <div className={cx(styles.ctaContainer, className)}>
      {items.map(item => (
        <Cta {...item} className={ctaClassName} key={item.text} />
      ))}
    </div>
  )
}

const Cta = ({
  className,
  url,
  forceInternal,
  onClick,
  text,
  textMobile,
  type = "button",
  color = "dark",
  variant = "primary",
  showArrow = true,
  isDisabled = false,
  isPlaceholder,
}) => {
  if (!(text && (url || onClick || type === "submit" || isPlaceholder))) {
    return null
  }

  const classNames = cx(styles.cta, styles[color], styles[variant], className, {
    [styles.isDisabled]: isDisabled,
  })
  const isOutsideLink = !isLocalLink(url)
  let arrowIcon = null

  if (showArrow) {
    if (isOutsideLink) {
      arrowIcon = <ArrowOut className={cx(styles.icon, styles.iconOut)} />
    } else if (variant === "textLink") {
      arrowIcon = <div className={styles.icon}>&#8594;</div>
    } else if (variant === "link") {
      arrowIcon = <ArrowRight className={styles.icon} />
    }
  }

  if (isPlaceholder) {
    return (
      <div className={classNames}>
        <span className={styles.text}>{text}</span>
        {arrowIcon}
      </div>
    )
  }

  return (
    <ConditionalWrapper
      condition={url}
      wrapper={wrapChildren => {
        return (
          <Link
            url={url}
            forceInternal={forceInternal}
            className={classNames}
            {...(onClick && {
              onClick: e => onClick(e),
            })}
          >
            {wrapChildren}
          </Link>
        )
      }}
      elseWrapper={wrapChildren => (
        <button
          className={classNames}
          type={type}
          {...(onClick && {
            onClick: e => onClick(e),
          })}
        >
          {wrapChildren}
        </button>
      )}
    >
      {textMobile && (
        <span className={cx(styles.text, styles.isMobile)}>{textMobile}</span>
      )}
      <span className={styles.text}>{text}</span>
      {arrowIcon}
    </ConditionalWrapper>
  )
}

export default Cta
